module.exports = __webpack_public_path__ + "fonts/pacifico-regular.5c8f62c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/owlin-for-you/fonts/pacifico-regular.woff
// module id = 391
// module chunks = 0